import { Colors } from 'styles';

export const MenuSeparator = (): React.ReactElement => (
  <hr
    css={`
      border: unset;
      border-top: 1px solid ${Colors.gray5};
      margin: 0;
    `}
  />
);
